import { Box } from "@radix-ui/themes";
import BackgroundHeader from "@assets/svg/background-header.svg?react";
import Stack from "@/components/ui/stack";
import Header from "./header/header";
import { Outlet } from "@tanstack/react-router";

export default function AppLayout() {
  return (
    <Box className="min-h-screen bg-[#F2F4F7] relative">
      <div className="absolute inset-x-0 top-0 h-[278px] overflow-hidden z-0">
        <BackgroundHeader
          className="block w-full h-full pointer-events-none"
          preserveAspectRatio="xMidYMid slice"
          aria-hidden
        />
      </div>

      <Stack
        gap={"32px"}
        className="relative z-10 w-full h-full px-[112px] pb-[32px]"
      >
        <Header />
        <Outlet />
      </Stack>
    </Box>
  );
}
